import { Icon } from '@iconify/react';
import { useTickets } from '../../contexts/TicketContext';
import { useAuthUser } from '../../contexts/AuthUserContext';
import { useState, useMemo } from 'react';

import TicketCard from './ticketCard';

const TicketLogs = () => {
    const { tickets } = useTickets();
    const user = useAuthUser();
    const [expandedMonths, setExpandedMonths] = useState({});

    // Filter tickets based on user role
    const filteredTickets = useMemo(() => {
        if (!user || !tickets) return tickets;
        
        // If user is client_user, only show tickets created by them
        if (user.role === 'client_user' || user.roles?.includes('client_user')) {
            return tickets.filter(ticket => ticket.email === user.email);
        }
        
        // For other roles (client_admin, helios_admin, helios_user), show all tickets (existing logic)
        return tickets;
    }, [tickets, user]);

    // Toggle expanded state for a specific month
    const handleExpand = (monthYear) => {
        setExpandedMonths((prev) => ({
            ...prev,
            [monthYear]: !(prev[monthYear] ?? true), // Default to true (expanded)
        }));
    };

    // Group tickets by month and year
    const groupTicketsByMonth = () => {
        const grouped = {};

        filteredTickets.forEach((ticket) => {
            if (!ticket.createdTime) return;

            const date = new Date(ticket.createdTime);
            const monthYear = date.toLocaleString('default', { month: 'long', year: 'numeric' });

            if (!grouped[monthYear]) {
                grouped[monthYear] = [];
            }
            grouped[monthYear].push(ticket);
        });

        return grouped;
    };

    const groupedTickets = groupTicketsByMonth();

    // Sort the groups by date (newest first)
    const sortedMonthYears = Object.keys(groupedTickets).sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB - dateA;
    });

    return (
        <div className="tickets-log-title-responsive">
            {sortedMonthYears.map((monthYear) => {
                const isExpanded = expandedMonths[monthYear] ?? true; // Default to expanded
                return (
                    <div key={monthYear} className="flex flex-col w-full gap-2 md:gap-3">
                        <div
                            className="tickets-month-header-responsive"
                            onClick={() => handleExpand(monthYear)}
                        >
                            <div className="flex flex-row items-center gap-2">
                                <Icon
                                    icon="material-symbols:calendar-month-outline-rounded"
                                    className="responsive-icon-sm text-secondary"
                                />
                                <span className="text-base font-semibold sm:text-lg text-font-primary">{monthYear}</span>
                            </div>
                            <Icon
                                icon={isExpanded ? "mingcute:up-line" : "mingcute:down-line"}
                                className="responsive-icon-sm text-secondary ml-auto"
                            />
                        </div>
                        {isExpanded && (
                            <div className="tickets-logs-responsive bg-background">
                                {groupedTickets[monthYear].map((ticket) => (
                                    <TicketCard
                                        key={ticket.id}
                                        ticket={ticket}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default TicketLogs;
